module.exports = __webpack_public_path__ + "static/media/windDriven.d6027475.png";